import styled from "styled-components"

import {RouterLink} from "@irati/ui/src/Link"
import {Label1} from "@irati/ui/src/Labels"
import {perkbox} from "@irati/ui/src/global/colors"
import {label1} from "@irati/ui/src/Labels/css/labels"
import Icon from "@irati/ui/src/Icon"

export const Text = styled(Label1)`
  display: inline-block;
`

export const Link = styled(RouterLink).attrs({
  uppercase: true,
  bold: true
})`
  color: ${perkbox.blue};
  ${label1}
`

export const Ul = styled.ul`
  margin: 0;
  padding: 0;
`

export const Li = styled.li`
  margin: 0;
  padding: 0;
  display: inline-flex;
  list-style-type: none;
  align-items: center;
`

interface ArrowProps {
  icon: string,
  size: number
}
export const Arrow = styled(Icon).attrs<ArrowProps>({
  icon: "angleRight",
  size: 12
})`
  margin-left: 10px;
  margin-right: 10px;
`
